var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIdea = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95146 9.5C9.90256 8.86771 10.5294 7.78641 10.5294 6.55871C10.5294 4.60947 8.94923 3.0293 6.99999 3.0293C5.05075 3.0293 3.47058 4.60947 3.47058 6.55871C3.47058 7.78641 4.09743 8.86771 5.04852 9.5C5.22386 9.61656 5.25225 9.86029 5.28125 10.1092C5.31373 10.388 5.34698 10.6734 5.58823 10.794C6.29411 11.1469 7.70588 11.1469 8.41176 10.794C8.62885 10.6855 8.63519 10.4717 8.64214 10.2373C8.6498 9.97866 8.65821 9.69495 8.95146 9.5ZM5.95109 6.32656C5.99217 6.20333 6.10165 5.99427 6.28396 5.82118C6.45978 5.65426 6.6929 5.52918 7.00012 5.52918C7.21129 5.52918 7.38247 5.358 7.38247 5.14683C7.38247 4.93566 7.21129 4.76448 7.00012 4.76448C6.46029 4.76448 6.04634 4.99233 5.75746 5.26659C5.47507 5.53469 5.3022 5.85503 5.22563 6.08474C5.15885 6.28507 5.26712 6.50161 5.46745 6.56838C5.66778 6.63516 5.88431 6.52689 5.95109 6.32656Z",
    fill: "#FFB801"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41176 6.55859H1",
    stroke: "#FFB801",
    strokeWidth: 0.764706,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76292 3.32151L2.76465 2.32324",
    stroke: "#FFB801",
    strokeWidth: 0.764706,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.97036L7 0.558594",
    stroke: "#FFB801",
    strokeWidth: 0.764706,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.237 3.32151L11.2352 2.32324",
    stroke: "#FFB801",
    strokeWidth: 0.764706,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5882 6.55859L13 6.55859",
    stroke: "#FFB801",
    strokeWidth: 0.764706,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58826 11.6281C5.58826 11.5572 5.64572 11.4998 5.7166 11.4998H8.28344C8.35433 11.4998 8.41179 11.5572 8.41179 11.6281C8.41179 12.3369 7.83718 12.9115 7.12836 12.9115H6.87168C6.16286 12.9115 5.58826 12.3369 5.58826 11.6281Z",
    fill: "#0C193B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIdea);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/idea.c1bd23b0a9cc3e7e7d23bf28eea0c92d.svg";